import Api from '../../app/services/api';

const getWarrantyStatstics = () => Api.get('/statistics/warranty');

const getBreakdownStatistics = () => Api.get('/statistics/breakdown');

const getClientStatistics = () => Api.get('/statistics/client');

const getVoivodeshipStatistic = (date) => Api.get('/statistics/voivodeship', { date });

const getReport = (dateFrom, dateTo, type) => Api.get('/statistics/reports', { dateFrom, dateTo, type });

const getReportBreakdowns = (dateFrom, dateTo, type) => Api.get('/statistics/reports-breakdowns', { dateFrom, dateTo, type });

const getReportBreakdownsComparasion = (dateFrom, dateTo, type, filters) => Api.get('/statistics/reports-breakdowns-comperasion', {
  dateFrom, dateTo, type, ...filters,
});

export {
  getWarrantyStatstics,
  getBreakdownStatistics,
  getClientStatistics,
  getVoivodeshipStatistic,
  getReport,
  getReportBreakdowns,
  getReportBreakdownsComparasion,
};
